import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Container, Header, Panel } from '../..';
import GBColor from '../../prop-types/GBColor';
import styles from './message.css';
var cx = classnames.bind(styles);

function MessageIcon(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["className"]);

  return React.createElement("div", _extends({
    className: cx('icon', className)
  }, rest));
}

MessageIcon.propTypes = {
  className: PropTypes.string
};
MessageIcon.defaultProps = {
  className: undefined
};

function MessageHeader(_ref2) {
  var className = _ref2.className,
      rest = _objectWithoutProperties(_ref2, ["className"]);

  return React.createElement(Header, _extends({
    as: "h4",
    className: cx('header', className)
  }, rest));
}

MessageHeader.propTypes = {
  className: PropTypes.string
};
MessageHeader.defaultProps = {
  className: undefined
};

function MessageContent(props) {
  return React.createElement("div", props);
}

export default function Message(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      color = _ref3.color,
      dismissable = _ref3.dismissable,
      header = _ref3.header,
      hidden = _ref3.hidden,
      icon = _ref3.icon,
      rest = _objectWithoutProperties(_ref3, ["children", "className", "color", "dismissable", "header", "hidden", "icon"]);

  var _useState = useState(!hidden),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  useEffect(function () {
    setVisible(!hidden);
  }, [hidden]);
  var handleDismiss = useCallback(function () {
    setVisible(false);
  }, []);
  return visible && React.createElement(Panel, _extends({
    bordered: true,
    rounded: true,
    translucent: true,
    className: cx('panel', _defineProperty({}, color, styles[color]), className),
    color: null,
    padded: false
  }, rest), React.createElement(Container, {
    fluid: true,
    className: cx('container')
  }, icon && React.createElement(MessageIcon, null, icon), header && React.createElement(MessageHeader, null, header), icon || header ? React.createElement(MessageContent, null, children) : children), dismissable && React.createElement(FontAwesomeIcon, {
    className: cx('closeIcon'),
    icon: faTimes,
    onClick: handleDismiss
  }));
}
Message.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  color: GBColor,
  dismissable: PropTypes.bool,
  header: PropTypes.string,
  hidden: PropTypes.bool,
  icon: PropTypes.node
};
Message.defaultProps = {
  children: undefined,
  className: undefined,
  color: 'grey',
  dismissable: false,
  header: undefined,
  hidden: false,
  icon: undefined
};
Message.Icon = MessageIcon;
Message.Header = MessageHeader;
Message.Content = MessageContent;